import { render, staticRenderFns } from "./team_members.vue?vue&type=template&id=e6c44d84"
import script from "./team_members.vue?vue&type=script&lang=js"
export * from "./team_members.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports